import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  tableWrapper: {
    overflowX: 'auto'
  },
  row: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  numberColumn: {
    width: 80
  },
  exceptionsColumn: {
    width: 140
  }
};

const GCIExceptionsTable = ({ classes, users, onSelectUser }) => (
  <Paper className={classes.tableWrapper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.numberColumn}>#</TableCell>
          <TableCell>Name</TableCell>
          <TableCell className={classes.exceptionsColumn}>Exceptions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {users.map((user, index) => (
          <TableRow
            hover
            className={classes.row}
            key={user.id}
            onClick={() => onSelectUser(user)}
          >
            <TableCell>{index + 1}</TableCell>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.exceptionCount}</TableCell>
          </TableRow>
        ))}
        {users.length === 0 && (
          <TableRow>
            <TableCell colSpan={3}>None</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </Paper>
);

export default withStyles(styles)(GCIExceptionsTable);
